export enum EDeviceType {
  Phone = 'phone',
  Tablet = 'tablet',
  Desktop = 'desktop',
}
